import './card-factor.scss';

export default () => {

};
